import { CouponSource, CouponSourceLabels } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';

export const COUPON_SOURCE_FILTER_OPTIONS: FilterOption<CouponSource>[] = [
  { value: CouponSource.STANDALONE, label: CouponSourceLabels.STANDALONE },
  { value: CouponSource.CAMPAIGN, label: CouponSourceLabels.CAMPAIGN },
  { value: CouponSource.REFERRAL, label: CouponSourceLabels.REFERRAL }
];
